import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';

const HistoryTemplate = ({ templateLink }: { templateLink: string }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'end', gap: '8px' }}>
      <BordOneToneIcon variant="document" customWidth="12px" standardSize={8} stroke="#0008" />
      <a
        href={templateLink}
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: 'underline', fontSize: '12px', lineHeight: '12px' }}
      >
        Ver Plantilla
      </a>
    </div>
  );
};

export default HistoryTemplate;
